module.exports = __webpack_public_path__ + "img/steward.b45cd50d.png";